module.exports = __webpack_public_path__ + "img/login.a1811e7e.png";